import { Controller } from '@hotwired/stimulus'

// Disables the submit button and shows loading text when the form is submitted.
export default class extends Controller {
  static values = { loadingText: String }

  submit() {
    const submitButton = this.element.querySelector('button[type="submit"], input[type="submit"]')
    if (!submitButton) return

    submitButton.disabled = true
    const loadingText = this.loadingTextValue || 'Loading...'

    if (submitButton.tagName === 'INPUT') {
      submitButton.dataset.originalValue = submitButton.value
      submitButton.value = loadingText
    } else {
      submitButton.dataset.originalText = submitButton.textContent
      submitButton.textContent = loadingText
    }
  }
}
